module.exports = __webpack_public_path__ + "0ef33c5aceb089db439dd965b64111a7.pdf";